import React, { useEffect } from "react";
import { useClient } from "ClientContext";
//translation
import { useTranslation } from "react-i18next";

interface ThingsToKnowProps {
  thingsToknow: {
    checkInTime?: string; // Make checkInTime optional
    checkOutTime?: string; // Make checkOutTime optional
  };
}

const ThingsToKnow: React.FC<ThingsToKnowProps> = ({ thingsToknow }) => {
  const { internal_ID } = useClient();

  const { t, i18n } = useTranslation();

  // Function to change language dynamically
  useEffect(() => {
    i18n.changeLanguage('fr'); // Change language to 'fr', 'en', etc.
  }, [])

  // Use provided check-in and check-out times, or default values if undefined
  const checkInTime = internal_ID === "f9ae756d-be1b-4593-87aa-c245416e4ae7" ? ("Flexible") : (thingsToknow?.checkInTime || "4:00 PM");
  const checkOutTime = internal_ID === "f9ae756d-be1b-4593-87aa-c245416e4ae7" ? ("Flexible") : (thingsToknow?.checkOutTime || "11:00 AM");

  return (
    <div className="listingSection__wrap">
      {/* HEADING */}
      <h2 className="text-2xl font-semibold">{t("Things to know")}</h2>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

      {/* CONTENT */}
      <div>
        <h4 className="text-lg font-semibold">{t("Check-in time")}</h4>
        <div className="mt-3 text-neutral-500 dark:text-neutral-400 max-w-md text-sm sm:text-base">
          <div className="flex space-x-10 justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
            <span>{t("Check-in")}</span>
            <span>{checkInTime}</span>
          </div>
          <div className="flex space-x-10 justify-between p-3">
            <span>{t("Check-out")}</span>
            <span>{checkOutTime}</span>
          </div>
        </div>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
    </div>
  );
};

export default ThingsToKnow;